"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var axiosMethodOverride = function axiosMethodOverride(axios) {
  axios.interceptors.request.use(function (config) {
    var method = config.method.toUpperCase();
    if (method === "PUT" || method === "DELETE" || method === "PATCH") {
      config.headers = _extends({}, config.headers, _defineProperty({}, "X-HTTP-Method-Override", method));
      config.method = "post";
      config.params = _extends({}, config.params, {
        _method: method
      });
    }
    return config;
  });
  return axios;
};

exports.default = axiosMethodOverride;


//////////////////
// WEBPACK FOOTER
// ./~/_axios-method-override@1.1.2@axios-method-override/lib/index.js
// module id = 136
// module chunks = 2